import React from 'react';

import { MarketState } from '../../lib/models/market-data/types';
import { useMarketStateInfo } from '../../lib/util/hooks/market/MarketStateInfoHook';

import styles from './MarketStateBadge.module.scss';

export const MarketStateBadge = (): JSX.Element => {
  const { statusLabel, marketState } = useMarketStateInfo();
  if (MarketState.PreMarket !== marketState) {
    return <></>;
  }

  return <div className={styles.container}>{statusLabel}</div>;
};
